import { render, staticRenderFns } from "./algooo.vue?vue&type=template&id=09e4964e&scoped=true"
import script from "./algooo.vue?vue&type=script&lang=js"
export * from "./algooo.vue?vue&type=script&lang=js"
import style0 from "./algooo.vue?vue&type=style&index=0&id=09e4964e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e4964e",
  null
  
)

export default component.exports